module.exports = __webpack_public_path__ + "static/cta-2-moc-2-c8c838790e239999b087455027238f86.png";